// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"12a5fb65","453":"458b8914"}[chunkId] + ".chunk.js";
};